export const Units = [
  { value: "1", label: "عدد" },
  { value: "2", label: "گرم" },
  { value: "3", label: "کیلوگرم" },
  { value: "4", label: "لیتر" },
  { value: "5", label: "متر" },
  { value: "6", label: "دستگاه" },
  { value: "7", label: "شاخه" },
  { value: "8", label: "بسته" },
  { value: "9", label: "پرس" },
  { value: "10", label: "متر مکعب" },
];

export const Vats = [
  { value: "0", label: "0%" },
  { value: "7", label: "7%" },
  { value: "10", label: "10%" },
  { value: "15", label: "15%" },
];
